import { render } from "./ManagerReviewForm.vue?vue&type=template&id=5d12d3db&scoped=true"
import script from "./ManagerReviewForm.vue?vue&type=script&lang=js"
export * from "./ManagerReviewForm.vue?vue&type=script&lang=js"

import "./ManagerReviewForm.vue?vue&type=style&index=0&id=5d12d3db&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d12d3db"]])

export default __exports__